import { render } from "./Home.vue?vue&type=template&id=7a9bedb8"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "@/styles/pages/_home.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script